export function normalizeCustomerFollowTime(value) {
  if (!value) return undefined
  return String(value).trim().replace(' ', 'T')
}
